import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./mainFieldManageSlice";

const selectDomain = (state) => state.mainFieldManage || initialState;

export const makeSelectAll = createSelector(selectDomain, (state) => state.all);

export const makeSelectQuery = createSelector(
  selectDomain,
  (state) => state.query
);

export const makeSelectOne = createSelector(selectDomain, (state) => state.one);
